import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  uploadBlueprintHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    '& p,li': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
    },
  },
  uploadBlueprintInstructionsHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
  },
  uploadBlueprintHeaderList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '19px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
    '&>li': {
      listStyleType: 'disc',
      listStylePosition: 'inside',
      '&::marker': {
        margin: 0,
        marginRight: '10px',
      },
    },
  },
  uploadBlueprintLabel: {
    border: `1px dashed ${theme.evPalette.charcoal[800]}`,
    width: '100%',
    cursor: 'pointer',
    margin: '0 auto',
    padding: '100px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    height: '302px',
  },
  uploadBlueprintLabelOnDrag: {
    border: `4px dashed ${theme.evPalette.ocean[600]}`,
    backgroundColor: theme.evPalette.ocean[100],
    '& *': {
      pointerEvents: 'none',
    },
  },
  uploadBlueprintLabelText: {
    color: theme.evPalette.charcoal[900],
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    whiteSpace: 'nowrap',
  },
  uploadBlueprintLabelErrorText: {
    display: 'flex',
    alignItems: 'center',
    color: theme.evPalette.rose[900],
    gap: '5px',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    padding: '24px',
  },
  uploadDifferentFileContainer: {
    flex: 1,
    rowGap: '8px',
    alignItems: 'flex-end',
  },
  uploadDifferentFileButton: {
    '@media (min-width: 640px)': { alignSelf: 'flex-end' },
  },
  uploadBlueprintFileName: {
    color: theme.evPalette.charcoal[900],
    gap: '5px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '18px',
  },
  iFrameComponent: {
    height: '500px',
    '@media (min-width: 1024px)': { flex: 1 },
  },
}));
